module.exports = __webpack_public_path__ + "img/photo-29.91d3fd15.jpg";